import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageHelper {
  public static setItem<T>(key: string, value: T): void {
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, String(value));
    }
  }

  public static getItem<T>(key: string): T | null {
    const data = localStorage.getItem(key);

    try {
      return (new Function("return " + data + ";"))();
    } catch(e) {
      return data as T;
    }
  }

  public static removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public static clear() {
    localStorage.clear();
  }
}